import { queryOptions } from '@tanstack/react-query'

import { getShipment, getShipmentCargoSummary } from './shipments.service'

export const shipmentQueryOptions = (shipmentId: string, enabled = true) =>
  queryOptions({
    queryKey: ['shipments', shipmentId],
    queryFn: async () => getShipment(shipmentId),
    enabled,
  })

export const shipmentCargoSummaryOptions = (shipmentCode: string, enabled = true) =>
  queryOptions({
    queryKey: ['shipment-cargo', shipmentCode],
    queryFn: async () => getShipmentCargoSummary(shipmentCode),
    enabled,
  })
